// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipWrap__B3H9dbbXDY{display:inline-flex}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/sidebar/cards/customFields/conversationCustomFieldsCard.module.scss"],"names":[],"mappings":"AAAA,yBACE,mBAAA","sourcesContent":[".tooltipWrap {\n  display: inline-flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipWrap": `tooltipWrap__B3H9dbbXDY`
};
export default ___CSS_LOADER_EXPORT___;
